


























































import path from 'path'
import { Route } from 'vue-router'
import { isExternal } from '@/utils/validate'
import { Component, Vue, Prop } from 'vue-property-decorator'
import AppLink from './Link.vue'

@Component({
  // Set 'name' here to prevent uglifyjs from causing recursive component not work
  // See https://medium.com/haiiro-io/element-component-name-with-vue-class-component-f3b435656561 for detail
  name: 'SidebarItem',
  components: {
    AppLink,
  },
})
export default class SidebarItem extends Vue {
  @Prop({ required: true }) private item!: Route;
  @Prop({ default: false }) private isNest!: boolean;
  @Prop({ default: false }) private collapse!: boolean;
  @Prop({ default: '' }) private basePath!: string;

  private onlyOneChild: Route | null = null;

  private hasOneShowingChild(children: Route[], parent: Route) {
    let showingChildren: Route[] = []

    if (children) {
      showingChildren = children.filter((item: Route) => {
        if (item.meta && item.meta.hidden) {
          return false
        } else {
          this.onlyOneChild = item
          return true
        }
      })
    }

    if (showingChildren.length === 1) {
      return true
    } else if (showingChildren.length === 0) {
      this.onlyOneChild = { ...parent, path: '', meta: { noShowingChildren: true } }
      return true
    }

    this.onlyOneChild = null
    return false
  }

  private resolvePath(routePath: string) {
    if (isExternal(routePath)) {
      return routePath
    }
    return path.resolve(this.basePath, routePath)
  }
}
